import React from 'react';
import {FormField as FormFieldType, FormData, FormErrors} from '../../../../../types/ContactForm';

interface RadioFieldProps {
    field: FormFieldType;
    formData: FormData;
    errors: FormErrors;
    inputCssClass?: string;
    onInputChange: (name: string, value: any) => void;
    onFieldFocus: (fieldName: string) => void;
}

export const RadioField: React.FC<RadioFieldProps> = ({
                                                          field,
                                                          formData,
                                                          errors,
                                                          onInputChange,
                                                          onFieldFocus
                                                      }) => {
    const handleInputChange = (value: any) => {
        onInputChange(field.name, value);
        onFieldFocus(field.name);
    };

    const radioOptions = field.options?.split('\n').map(opt => opt.trim()).filter(opt => opt) || [];

    return (
        <div className={`col-12 col-md-${field.width || 12} zr-input-radio`}>
            <div className={`${field.required ? 'required' : ''} ${errors[field.name] ? 'has-error' : ''}`}>
                <fieldset>
                    <legend className="control-label">
                        {field.label}
                    </legend>
                    {radioOptions.map((option, index) => (
                        <div key={index} className="form-check">
                            <input
                                type="radio"
                                id={`field-${field.id}-${index}`}
                                name={field.name}
                                value={option}
                                className="form-check-input"
                                checked={formData[field.name] === option}
                                onChange={(e) => handleInputChange(e.target.value)}
                                required={field.required && index === 0}
                                aria-required={field.required && index === 0}
                            />
                            <label htmlFor={`field-${field.id}-${index}`}
                                   className="form-check-label">{option}</label>
                        </div>
                    ))}
                </fieldset>
                {errors[field.name] && (
                    <div className="form-error-msg text-danger">
                        <i className="fa fa-warning"></i> {errors[field.name]}
                    </div>
                )}
            </div>
        </div>
    );
};

